export default function useCompanyData() {
  const { companyData } = useFeatureFlagsNew();

  function getCompanyData(key: keyof FeatureCompanyData): string {
    return companyData.value[key] || '';
  }

  const companyShortName = computed(() => {
    return getCompanyData('COMPANY_SHORT_NAME') || appName();
  });

  const companyFullName = computed(() => {
    return getCompanyData('COMPANY_FULL_NAME') || companyShortName.value;
  });

  const companyCnpj = computed(() => {
    return getCompanyData('COMPANY_CNPJ') || '';
  });

  const companyAddress = computed(() => {
    return getCompanyData('COMPANY_ADDRESS') || '';
  });

  const companySupportEmail = computed(() => {
    return getCompanyData('COMPANY_SUPPORT_EMAIL') || '';
  });

  const companyInfoEmail = computed(() => {
    return getCompanyData('COMPANY_INFO_EMAIL') || '';
  });

  const companyDopEmail = computed(() => {
    return getCompanyData('COMPANY_DOP_EMAIL') || '';
  });

  const companyPhone = computed(() => {
    return getCompanyData('COMPANY_PHONE') || '';
  });

  return {
    getCompanyData,
    companyShortName,
    companyFullName,
    companyCnpj,
    companyAddress,
    companySupportEmail,
    companyInfoEmail,
    companyDopEmail,
    companyPhone,
  };
}
